<template>
  <div id="todo-item-active" class="todo-item" ref="currentTodo" draggable="true"
    @dragstart="startDrag($event, activeTodo.toDo, activeTodo.index)" @dragend="endDrag()" @wheel="movingWheel"
    :class="{ 'dragging': todoDragging }" @mouseleave="hideToDoItem">
    <div class="d-flex">
      <span class="noselect item-text" :class="{ 'checked-todo': activeTodo.toDo.checked }" style="flex-grow: 1"
        @click="checkTodoClickhandler" @click.middle="showToDoDetails">
        <span v-if="activeTodo.toDo.color != 'none'" class="cicle-icon" :style="'color: ' + activeTodo.toDo.color" :class="{
          'bi-check-circle-fill': activeTodo.toDo.checked,
          'bi-circle-fill': !activeTodo.toDo.checked,
        }"></span>
        <span v-else class="cicle-icon"
          :class="{ 'bi-check-circle': activeTodo.toDo.checked, 'bi-circle': !activeTodo.toDo.checked, }"></span>
        <span v-html="todoText"></span>
        <span class="time-details"> {{ timeFormat(activeTodo.toDo.time) }}
          <div class="alarm-indicator"
            :class="{ 'show-alarm-indicator': notificationIndicator && activeTodo.toDo.alarm }"></div>
        </span>
      </span>
      <i class="bi-three-dots todo-item-menu" type="button" @click="showToDoDetails"></i>
      <i class="bi-x todo-item-remove" @click="removeTodo"></i>
    </div>

    <div v-if="activeTodo.toDo.subTaskList && activeTodo.toDo.subTaskList.length > 0" class="todo-item-sub-tasks">
      <ul class="sub-tasks">
        <li v-for="(subTask, index) in activeTodo.toDo.subTaskList" :key="index" class="sub-task">
          <div class="d-flex flex-row mt-1" :class="{ 'checked-sub-task': subTask.checked }">
            <input class="form-check-input" type="checkbox" v-model="subTask.checked"
              @change="checkSubTask(subTask, index, $event)" />
            <label class="form-check-label" @click="checkSubTask(subTask, index, $event)">
              <span v-html="linkifyText(subTask.text)"></span>
            </label>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import toDoListRepository from "../repositories/toDoListRepository";
import { Modal, Toast } from "bootstrap";
import moment from "moment";
import notifications from "../helpers/notifications";
import linkifyStr from 'linkify-string';
import ClickHandler from "@manuelernestog/click-handler";
import tasksHelper from "../helpers/tasksHelper";

function afterTodoWrite(promise, fn) {
  Promise.resolve(promise).then((result) => {
    let ok = false;
    try {
      ok = require("../helpers/todoActivityLog.js").isTodoWriteOk(result);
    } catch (_) {
      ok = false;
    }
    if (!ok) return;
    fn();
  }, () => {});
}

function afterTodoDelete(promise, fn) {
  Promise.resolve(promise).then((result) => {
    let ok = false;
    try {
      ok = require("../helpers/todoActivityLog.js").isTodoDeleteWriteOk(result);
    } catch (_) {
      ok = false;
    }
    if (!ok) return;
    fn();
  }, () => {});
}

function beginUndoNotesCascade(todoId) {
  try {
    return require("../helpers/todoActivityLog.js").planUndoableNotesCascade(todoId);
  } catch (_) {
    return { commit() {} };
  }
}

function showTaskRemovedToast() {
  const toastEl = document.getElementById("taskRemoved");
  if (!toastEl) return 0;
  const toast = new Toast(toastEl);
  const configured = toast._config && toast._config.delay;
  toast.show();
  if (typeof configured === "number" && configured >= 0) return configured;
  try {
    return require("../helpers/todoActivityLog.js").UNDO_TOAST_MS;
  } catch (_) {
    return 5000;
  }
}

function commitUndoNotesCascade(plan, delayMs, readList) {
  try {
    const { deleteNotesByTodoId } = require("../sync/engine");
    const { shouldCascadeTodoNotes } = require("../helpers/todoActivityLog.js");
    plan.commit({
      deleteFn: (todoId) => {
        const list = typeof readList === "function" ? readList() : readList;
        if (!shouldCascadeTodoNotes(list, todoId)) return;
        return deleteNotesByTodoId(todoId);
      },
      delayMs,
    });
  } catch (_) {
    /* cascade must not block the todo delete */
  }
}

function logActivity(vm, type, todo, listId, meta) {
  try {
    const { logTodoActivity } = require("../helpers/todoActivityLog.js");
    const { createNote } = require("../sync/engine");
    const pending = logTodoActivity({
      type,
      todo,
      listId,
      meta,
      t: vm.$t.bind(vm),
      createNoteFn: createNote,
    });
    if (pending && typeof pending.then === "function") pending.then(() => {}, () => {});
  } catch (err) {
    /* activity log must not block the todo write */
  }
}

export default {
  components: {},
  props: {
    activeTodo: { required: true, type: Object }
  },
  data() {
    return {
      editing: false,
      todoDragHover: false,
      todoDragging: false,
      options: { target: '_blank', defaultProtocol: 'https' },
      clickhandler: new ClickHandler(),
      scrollingTimeOut: null
    };
  },
  methods: {
    removeTodo: function () {
      const listId = this.activeTodo.toDoListId;
      const todo = this.activeTodo.toDo;
      const todoId = todo && todo.id;
      if (todo && todo.repeatingEvent) {
        const repeatingEventHelper = require("../helpers/repeatingEvents.js").default;
        repeatingEventHelper.markDayHandled(this, listId, todo.repeatingEvent);
      }
      this.$store.commit("setUndoElement", { type: 'task', todo: this.activeTodo.toDo, index: this.activeTodo.index });
      this.$store.commit("removeTodo", { toDoListId: listId, index: this.activeTodo.index, });
      notifications.refreshDayNotifications(this, listId);
      const written = toDoListRepository.update(listId, this.$store.getters.todoLists[listId]);
      const notesCascade = beginUndoNotesCascade(todoId);
      const undoDelay = showTaskRemovedToast();
      afterTodoDelete(written, () =>
        commitUndoNotesCascade(notesCascade, undoDelay, () => this.$store.getters.todoLists[listId])
      );
      // The undo remove action is called in todoModal.vue:undoRemoveTask
      this.hideToDoItem();
    },
    showToDoDetails: function () {
      this.$store.commit("actionsSelectedTodoIdUpdate", {
        toDo: this.activeTodo.toDo,
        index: this.activeTodo.index,
      });

      const modalEl = document.getElementById("toDoModal");
      const modal = Modal.getOrCreateInstance(modalEl, { keyboard: false });
      setTimeout(() => modal.show(), 0);
    },
    checkTodoClickhandler: function (e) {
      if (e.target.href) return;

      const toDoListId = this.activeTodo.toDoListId;
      const index = this.activeTodo.index;
      const todo = this.activeTodo.toDo;
      this.$store.commit("checkTodo", { toDoListId, index });
      const activityType = todo && todo.checked ? "completed" : "uncompleted";
      const activityTodo = todo ? { id: todo.id, text: todo.text } : null;
      this.clickhandler.handle(
        () => { this.checkToDo(toDoListId, activityTodo, activityType); },
        this.activeTodo.edit,
        `${toDoListId}${index}`
      );
    },
    checkToDo: function (toDoListId, activityTodo, activityType) {
      const list = this.$store.getters.todoLists[toDoListId];
      const config = this.$store.getters.config;
      if (config.autoReorderTasks || tasksHelper.shouldMoveCompletedToBottom(config)) {
        this.$refs.currentTodo.style.display = `none`;
      }
      tasksHelper.applyListOrder(list, config);
      const written = toDoListRepository.update(toDoListId, list);
      notifications.refreshDayNotifications(this, toDoListId);
      afterTodoWrite(written, () => {
        logActivity(this, activityType, activityTodo, toDoListId);
      });
    },
    startDrag: function (event, item, index) {
      event.dataTransfer.dropEffect = "move";
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("item", JSON.stringify(item));
      event.dataTransfer.setData("index", index);
      event.dataTransfer.setDragImage(this.activeTodo.container, 0, 0);
      setTimeout(() => {
        this.$refs.currentTodo.style.display = `none`;
        this.todoDragging = true;
      }, 40);
      document.getElementById("app-container").classList.add("dragging-item");
    },
    endDrag: function () {
      this.todoDragging = false;
      document.getElementById("app-container").classList.remove("dragging-item");
    },
    onDragenter: function () {
      this.todoDragHover = true;
    },
    onDragleave: function () {
      this.todoDragHover = false;
    },
    checkSubTask: function (subTask, index, e) {
      if (e.target.href) return;

      if (!e.target.value) subTask.checked = !subTask.checked;
      var todoList = this.activeTodo.toDo.subTaskList;
      if (subTask.checked && this.moveSubtaskToBotttom) { todoList.push(todoList.splice(index, 1)[0]); }
      toDoListRepository.update(this.activeTodo.toDoListId, this.$store.getters.todoLists[this.activeTodo.toDoListId]);
    },
    timeFormat: function (date) {
      if (date) {
        return moment(date, "HH:mm").format("hh:mm a");
      }
    },
    linkifyText: function (text) {
      return linkifyStr(text, this.options);
    },
    hideToDoItem: function () {
      this.$refs.currentTodo.style.display = `none`;
    },
    movingWheel() {
      this.$refs.currentTodo.style.display = `none`;
      this.$refs.currentTodo.classList.add("scrolling");
      document.getElementById("app-container").classList.add("scrolling");
      if (this.scrollingTimeOut != null) return;

      this.scrollingTimeOut = setTimeout(() => {
        this.scrollingTimeOut = null;
        document.onmousemove = function () {
          document.onmousemove = null;
          document.getElementById("todo-item-active").classList.remove("scrolling");
          document.getElementById("app-container").classList.remove("scrolling");
        }
      }, 400);
    }
  },
  computed: {
    todoText: function () {
      return linkifyStr(this.activeTodo.toDo.text, this.options);
    },
    notificationIndicator: function () {
      return this.$store.getters.config.notificationIndicator;
    },
    moveSubtaskToBotttom: function () {
      return this.$store.getters.config.moveCompletedSubTaskToBottom;
    },
  }
};
</script>

<style scoped lang="scss">
.todo-item {
  background-color: #ffffff;
  color: #1e1e1e;
  border-radius: 7px;
  position: relative;
  box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.15);
  z-index: 6;
  position: absolute;
  display: none;

  &:hover {
    display: block;
  }

  * {
    transition: all 0.4s cubic-bezier(0.2, 1, 0.1, 1) 0s;
    pointer-events: all;
  }

  .dark-theme & {
    box-shadow: 0 0px 0 1px #4c4c4c;
    background-color: #21262d;
    color: #f7f7f7;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
  }

  .item-text {
    white-space: unset;
    word-break: normal;
    height: unset;
    overflow-wrap: break-word;
    word-wrap: break-word;
    z-index: 1;
  }
}

.todo-item.scrolling {
  display: none !important;
}

.item-text {
  transition: width 2s, height 2s, transform 2s;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 1rem;
  height: 1.2rem;
  line-height: 1.3rem;
  font-size: 0.865rem;
  margin: 2px 0px 2px 0px;
  padding: 0 3px 0 7px;
}

.item-time {
  transition: width 2s, height 2s, transform 2s;
  height: 1.2rem;
  line-height: 1.3rem;
  font-size: 0.865rem;
  margin: 2px 0px 2px 0px;
  padding: 0 7px 0 0px;
  opacity: 0.6;
}

.item-time.checked-todo {
  opacity: unset;
}

.time-details {
  opacity: 0.6;
  display: inline;
  margin-left: 5px;
}

.todo-item.checked-todo .time-details {
  opacity: unset;
}

.checked-todo {
  color: #acacac;
  text-decoration: line-through;

  .dark-theme & {
    color: #636363;
  }
}

.checked-sub-task {
  color: #c4c4c4;
  text-decoration: line-through;

  .dark-theme & {
    color: #3a3a40;
  }

  input {
    opacity: 0.5;
  }
}

.todo-item-remove {
  font-size: 1.3rem;
  cursor: pointer;
  margin-top: 1px;
  margin-left: 5px;
  margin-right: 5px;
  color: grey;
  height: 1.3rem;
  flex-grow: 0;
}

.todo-item-menu {
  font-size: 1rem;
  cursor: pointer;
  margin-top: 3px;
  margin-left: 5px;
  margin-right: 0px;
  color: grey;
  height: 1.1rem;
  flex-grow: 0;
}

.todo-item-remove:hover,
.todo-item-menu:hover {
  color: black;
}

.dark-theme .todo-item-remove,
.dark-theme .todo-item-menu {
  color: #c9d1d9;
}

.dark-theme .todo-item-remove:hover,
.dark-theme .todo-item-menu:hover {
  color: white;
}

.drag-hover {
  color: rgba(157, 157, 157, 0.43);
  box-shadow: rgb(244, 243, 243) 0px 0px 4px 1px inset;
  background-color: rgb(250, 249, 249);
}

.dark-theme .drag-hover {
  color: rgb(69, 69, 69);
  box-shadow: #0b0d12 0px 0px 4px 1px inset;
  background-color: #0c0d14;
}

.dragging.todo-item {
  display: none;
}

.sub-tasks {
  list-style: none;
  padding: 0px;
  font-size: 0.865rem;

  li {
    margin: 0px 10px 0px 10px;
  }

  li:last-child {
    margin: 0px 10px 10px 10px;
  }

  input {
    min-width: 14px;
    width: 14px;
    min-height: 14px;
    height: 14px;
    margin-right: 8px;
  }

  label {
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.cicle-icon {
  font-size: 10px;
  margin-right: 5px;
}

.bi-check-circle-fill,
.bi-check-circle {
  opacity: 0.7;
}
</style>
